export default __webpack_public_path__ + "static/PROUD_xs-5b3445e4e3c7610126e7994ddd13bdfd.webp";